@if (form) {
<div>
	<lib-card [isForm]="true" [title]="'Avatar'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[isRequired]="false"
			[imageCrop]="imageCrop"
			[uploadFunction]="uploadFunction"
			[valueAsSignal]="form.uploadedAvatar"
			(valueChange)="handleUploadImage($event)"
		></ui-file-form-field>
	</lib-card>
</div>
}
